(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
  class AnnouncementBar extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(e) {
      e.preventDefault();
      const { closeAnnouncement } = e.target.dataset;
      if (closeAnnouncement === 'row') {
        e.target.closest('.announcement-bar__row').remove();
      } else {
        this.remove();
      }
    }

    connectedCallback() {
      if (this.querySelector('.announcement-bar__close')) {
        this.querySelector('.announcement-bar__close').addEventListener('click', this.handleClick.bind(this));
      }
    }
  }

  customElements.define('announcement-bar', AnnouncementBar);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["boba-newsletter"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('boba-newsletter')) {
    customElements.define('boba-newsletter', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
        this.preview = new URLSearchParams(location.search).get('boba_popup_preview') === '1';
        this.closeKey = 'boba_newsletter_closed_until';
        this.signupKey = 'boba_newsletter_subscribed';
        this.onClose = () => {
          if (!this.preview) this.write(this.closeKey, String(Date.now() + Number(this.dataset.repeatDays || 1) * 86400000));
          this.dialog.close();
          document.documentElement.style.overflow = this.previousOverflow || '';
          this.previousFocus?.focus();
        };
        this.querySelectorAll('[data-close]').forEach(button => button.addEventListener('click', this.onClose));
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.onClose(); });
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.onClose();
        });
        const success = this.querySelector('[data-signup-success]');
        const error = this.querySelector('[data-signup-error]');
        this.querySelector('[data-copy-code]')?.addEventListener('click', event => this.copyCode(event.currentTarget));
        this.querySelector('[data-discount-code]')?.addEventListener('click', event => event.currentTarget.select());
        if (success) {
          this.dialog.setAttribute('aria-describedby', success.id);
          if (!this.preview) this.write(this.signupKey, '1');
          this.open();
          success.focus();
          return;
        }
        if (error) { this.open(); return; }
        if (!this.preview && (this.read(this.signupKey) === '1' || Number(this.read(this.closeKey)) > Date.now())) return;
        this.timer = setTimeout(() => this.open(), this.preview ? 0 : Number(this.dataset.delay || 15) * 1000);
      }
      async copyCode(button) {
        const input = this.querySelector('[data-discount-code]');
        const status = this.querySelector('[data-copy-status]');
        if (!input || !status) return;
        status.textContent = '';
        button.disabled = true;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(input.value);
          button.textContent = button.dataset.copiedLabel;
          status.textContent = button.dataset.copiedLabel;
        } catch {
          input.focus();
          input.select();
          input.setSelectionRange(0, input.value.length);
          button.textContent = button.dataset.copyLabel;
          status.textContent = button.dataset.copyFallback;
        } finally {
          button.disabled = false;
        }
      }
      open() {
        if (!this.isConnected || this.dialog.open || document.querySelector('dialog[open], .f-popup[open], .modal[open]')) return;
        this.previousFocus = document.activeElement;
        this.previousOverflow = document.documentElement.style.overflow;
        this.dialog.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      disconnectedCallback() { clearTimeout(this.timer); if (this.dialog?.open) this.onClose(); }
      read(key) { try { return localStorage.getItem(key); } catch { return null; } }
      write(key, value) { try { localStorage.setItem(key, value); } catch {} }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class FooterCollapsible extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.summaryIsEmpty = this.summary.textContent.trim().length == 0;
      this.openDefault = this.dataset.openDefault === 'true';

      this.details.addEventListener(
        'keyup',
        (event) => event.code.toUpperCase() === 'ESCAPE' && this.close()
      );
      this.summary.addEventListener('click', this.onSummaryClick.bind(this));
      document.addEventListener('matchTablet', this.close.bind(this));
      document.addEventListener('unmatchTablet', this.open.bind(this));

      if (FoxThemeSettings.isTablet) {
        if (!this.openDefault) this.close();
      }

      document.addEventListener('matchTablet', () => {
        if (!this.openDefault) {
          this.close();
        } else {
          this.open();
        }
      });

      document.addEventListener('unmatchTablet', () => {
        this.open();
      });
    }

    onSummaryClick(event) {
      event.preventDefault();
      event.target.closest('details').hasAttribute('open')
        ? this.close()
        : this.open();
    }

    open() {
      this.details.setAttribute('open', true);
    }

    close() {
      !this.summaryIsEmpty && this.details.removeAttribute('open');
    }
  }

  customElements.define('footer-collapsible', FooterCollapsible);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mobile-sticky-bar"]) return;
  try {
    
  class MobileStickyBar extends HTMLElement {
    constructor() {
      super();
      document.body.classList.add('mobile-sticky-bar-enabled');
    }

    connectedCallback() {
      document.documentElement.style.setProperty('--f-mobile-navbar-height', this.offsetHeight + 'px');
    }
  }
  customElements.define('mobile-sticky-bar', MobileStickyBar);

  } catch(e) { console.error(e); }
})();
})();
